import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Injector,
  forwardRef,
} from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { AmountSpinnerComponent } from "../../../../shared/base-components/amount-spinner.component";
import {
  NUMBER_SPINNER_INPUTS,
  NUMBER_SPINNER_VIEW_PROVIDERS,
  UpdateMode,
} from "shared/base-components/number-spinner.component";
// services
import { CcyPromiseLookupService } from "shared/cubiq-services/lookup/model/impl/CcyPromiseLookupService";
import { BfxFieldNumberDirective } from "../../../../shared/base-components/bfx-field-number";
import { BfxInputDirective } from "../../../../shared/base-components/bfx-input";

export const AMOUNT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxAmountSpinnerComponent),
  multi: true,
};

/**
 * Class that delegates straight through to standard amount spinner
 */
@Component({
  selector: "bfx-amount-spinner",
  templateUrl: "../../../../shared/base-components/html/number-spinner.html",
  providers: [AMOUNT_VALUE_ACCESSOR],
  viewProviders: NUMBER_SPINNER_VIEW_PROVIDERS,
  inputs: NUMBER_SPINNER_INPUTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxAmountSpinnerComponent extends AmountSpinnerComponent {
  constructor(
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldNumberDirective,
    currencyPromiseService: CcyPromiseLookupService,
    public el: ElementRef,
  ) {
    super(injector, inputDirective, fieldDirective, currencyPromiseService, el);

    // Ensure values must be greater than 0 when validating
    this.minMaxTouchValid = false;
  }
}
